import React, { Component } from 'react';
import {
  OkedSelectTrigger,
  KatoSelectTrigger,
  SelectOption,
} from '@app/components';
import { Card, CardContent } from 'components/ui/card';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import { Alert } from 'components/ui/alert';
import Logo from './logo.png';
import { Oked, Kato } from '@app/models';
import { createContactRequestWeb } from '@app/api';

interface Props {}

interface State {
  userType: 'supplier' | 'customer';
  oked: Oked | null;
  kato: Kato | null;
  phone: string;
  isSubmitting: boolean;
  error: string | null;
  isSubmitted: boolean;
}

class ContactRequestsWebPage extends Component<Props, State> {
  state: State = {
    userType: 'supplier',
    oked: null,
    kato: null,
    phone: '',
    isSubmitting: false,
    error: null,
    isSubmitted: false,
  };

  handleUserTypeChange = (type: 'supplier' | 'customer') => {
    this.setState({ userType: type });
  };

  handleOkedChange = (data: SelectOption<Oked>) => {
    this.setState({ oked: data.value });
  };

  handleKatoChange = (data: SelectOption<Kato>) => {
    this.setState({ kato: data.value });
  };

  handlePhoneChange = (value: string) => {
    this.setState({
      phone: value,
    });
  };

  handleSubmit = async () => {
    const { userType, oked, kato, phone, isSubmitted } = this.state;

    if (isSubmitted) {
      window.location.href = '/';
      return;
    }

    if (!this.isFormValid()) {
      return;
    }

    this.setState({ isSubmitting: true, error: null });

    const requestData = {
      phone,
      okedCode: oked!.code,
      katoCode: kato!.code,
      isSupplier: userType === 'supplier',
    };

    try {
      await createContactRequestWeb(requestData);

      this.setState({
        isSubmitting: false,
        isSubmitted: true,
      });
    } catch (error: any) {
      console.error('Error submitting form:', error);
      this.setState({
        isSubmitting: false,
        error:
          error.response?.data?.message ||
          'Произошла ошибка при отправке заявки. Попробуйте еще раз.',
      });
    }
  };

  isFormValid = () => {
    const { oked, kato, phone, isSubmitted } = this.state;
    return isSubmitted || (oked !== null && kato !== null && phone.length > 9);
  };

  render() {
    const { userType, oked, kato, phone, isSubmitting, error, isSubmitted } =
      this.state;
    return (
      <Card className="max-w-xl mx-auto p-6 bg-white min-h-screen">
        <CardContent>
          <div className="flex items-center gap-3 mb-6">
            <img src={Logo} className="w-8 h-10" />
            <div className="flex flex-col">
              <h2 className="font-medium text-xl m-0 p-0 text-black">SMR</h2>
              <p className="text-xs text-muted-foreground m-0 p-0">
                Поиск подряда и поставщиков
              </p>
            </div>
          </div>
          {isSubmitted ? (
            <Alert variant="default" className="mb-4 text-center">
              <h2 className="text-2xl font-semibold mb-2 text-green-700">
                Регистрация прошла успешно!
              </h2>
              <p>
                Вот ваши данные:
                <br />
                Тип: {userType === 'supplier' ? 'Поставщик' : 'Покупатель'}
                <br />
                Категория: {oked?.nameRu}
                <br />
                Регион: {kato?.nameRu}
                <br />
                Телефон: {phone}
              </p>
            </Alert>
          ) : (
            <>
              <div className="flex gap-3 mb-8">
                <Button
                  variant={userType === 'supplier' ? 'default' : 'outline'}
                  onClick={() => this.handleUserTypeChange('supplier')}
                  disabled={isSubmitting}
                  className="flex-1"
                >
                  Я предлагаю услуги
                </Button>
                <Button
                  variant={userType === 'customer' ? 'default' : 'outline'}
                  onClick={() => this.handleUserTypeChange('customer')}
                  disabled={isSubmitting}
                  className="flex-1"
                >
                  Я хочу найти исполнителя
                </Button>
              </div>
              <h2 className="text-2xl font-semibold mb-5 text-gray-800">
                {userType === 'supplier'
                  ? 'Что именно вы предлагаете?'
                  : 'Что вы хотите найти?'}
              </h2>
              {error && (
                <Alert variant="destructive" className="mb-4">
                  {error}
                </Alert>
              )}
              <div className="mb-6">
                <OkedSelectTrigger
                  label="Выберите категорию"
                  value={oked ? oked.nameRu : ''}
                  onChange={this.handleOkedChange}
                  helperText={''}
                  error={false}
                />
              </div>
              <div className="mb-6">
                <KatoSelectTrigger
                  label="Выберите регион"
                  value={(kato ? kato.nameRu : '') || undefined}
                  onChange={this.handleKatoChange}
                  helperText={''}
                  error={false}
                />
              </div>
              <div className="mb-6">
                <Input
                  placeholder="(777) 777 77 77"
                  value={phone}
                  onChange={(e) => this.handlePhoneChange(e.target.value)}
                  disabled={isSubmitting}
                  className="mb-2"
                />
              </div>
            </>
          )}
          <Button
            onClick={this.handleSubmit}
            disabled={!this.isFormValid() || isSubmitting}
            className="w-full mt-4"
          >
            {isSubmitting
              ? 'Отправка...'
              : isSubmitted
              ? 'Перейти на главную'
              : 'Продолжить'}
          </Button>
        </CardContent>
      </Card>
    );
  }
}

export default ContactRequestsWebPage;
